export default __webpack_public_path__ + "691d16d66f6e8509aade8be8944ad8f1.png";